




import { Component, Vue, Emit } from "vue-property-decorator";

@Component({})
export default class SidebarMinimizer extends Vue {
  @Emit()
  public sidebarMinimize() {
    document.body.classList.toggle("sidebar-minimized");
  }

  @Emit()
  public brandMinimize() {
    document.body.classList.toggle("brand-minimized");
  }
}
